// extracted by mini-css-extract-plugin
export var cartContainer = "_o3-4";
export var gray = "_o3-1";
export var itemContainer = "_o3-2";
export var itemDetails = "_o3-3";
export var strong = "_o3-0";